module.exports = __webpack_public_path__ + "img/手机_mobile.132ba4e3.png";